import { useEffect } from 'react';

import { endActivitySession, startActivitySession } from '@common/services/activity-session/activity-session';

interface UseActivitySessionArgs {
  organisationId?: string;
  enabled: boolean;
}

export function useActivitySession({ organisationId, enabled }: UseActivitySessionArgs) {
  useEffect(() => {
    if (!enabled || !organisationId) return undefined;

    startActivitySession(organisationId);

    return () => {
      endActivitySession();
    };
  }, [enabled, organisationId]);
}
